import "ngstorage";

import {WALKTHROUGH_STATES, TRIGGER_NEXT_EVENT_NAME, UPDATE_WORKFLOW_EVENT_NAME} from "../../variables";

class QuestionsController {
  constructor($localStorage, $rootScope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
    this.name = "questions";
    this.walkthroughState = WALKTHROUGH_STATES.QUESTIONS;

    this.$localStorage = $localStorage;
    this.$rootScope = $rootScope;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$auth = AuthService;
    this.$env = EnvService;
    this.$security = SecurityService;
    this.$timeout = $timeout;
    this.$tracking = TrackingService;
    this.$events = events;

    this.API_FIELDS = "surveyQuestions.id,surveyQuestions.name,surveyQuestions.question,surveyQuestions.questionType";

    this.ALL_QUESTIONS = [
      "Can you make all of the shifts?",
      "Do you have relevant work experience?",
      "Are you looking for permanent employment?",
      "Are you flexible to work extended hours?",
      "Have you worked for this company before?",
      "Have you worked for similar companies; which ones?",
    ];

    this.QUESTIONS = [
      "Can you make all of the shifts?",
      "Do you have relevant work experience?",
      "Are you looking for permanent employment?",
      "Are you flexible to work extended hours?",
      "Have you worked for this company before?",
      "Have you worked for similar companies; which ones?",
    ];

    console.log("Initialize Questions", localStorage.savingQuestions);
  }

  $onInit() {
    this.filterQuestions();

    this.syncWithApi();
  }

  syncWithApi() {
    this.$events
      .getEventByIdWithFields(this.event.id, this.API_FIELDS)
      .then((data) => {
        if (!(localStorage.savingQuestions && JSON.parse(localStorage.savingQuestions))) {
          console.log("Updating Questions");

          this.event.questions = data.data.surveyQuestions;
          this.event.questions = this.event.questions.sort((a, b) => {
            return a.id - b.id;
          });
          this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {});
          this.filterQuestions();
        } else {
          console.warn("Skipping Question Update");
        }
      })
      .catch((err) => {
        console.error("Failed to LOAD questions from API:", err);
      });
  }

  filterQuestions() {
    if (!this.event.questions) return;

    const questions = this.event.questions.map((q) => q.question);

    this.QUESTIONS = _.difference(this.ALL_QUESTIONS, questions);
  }

  goNext() {
    if (this.showCustom) {
      this.addQuestion(this.question, true);
    }

    this.$rootScope.$emit(TRIGGER_NEXT_EVENT_NAME, {
      walkthroughState: this.walkthroughState,
    });
  }

  addQuestion(q, custom) {
    if (!q || !q.length) return;

    if (q === "CUSTOM") {
      this.newQuesiton = null;
      this.showCustom = true;
      return;
    }

    if (custom) {
      this.showCustom = false;
    }

    if (this.event.questions.length >= 5) {
      this.newQuesiton = null;
      this.$tracking.reportPostAJobSubmitStep("more than 5 questions");
      return alert("You can only have a maximum of 5 questions.");
    }

    const qo = {
      question: q,
      questionType: {id: 1, name: "Text", description: null},
      editing: false,
    };

    this.event.questions.push(qo);

    this.filterQuestions();
    this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {});

    const data = {
      event_id: this.event.id,
      questions: this.event.questions,
    };

    localStorage.savingQuestions = true;

    this.$events
      .updateQuestion(data)
      .then((data) => {
        localStorage.savingQuestions = false;

        this.$tracking.reportPostAJobSubmitStep("questions");

        if (custom) {
          this.$tracking.reportPostAJobSubmitStep("custom question");
        } else {
          this.$tracking.reportPostAJobSubmitStep("predefined question");
        }

        console.log("Saved questions:", data);
        this.$timeout(() => {
          this.syncWithApi();
        }, 500);
      })
      .catch((err) => {
        console.error("Failed to SAVE questions to API:", err);
      });

    this.question = "";
  }

  removeQuestion(index, question) {
    let payload = {
      event_id: this.event.id,
      question_ids: [question.id],
    };

    localStorage.savingQuestions = true;

    this.$events
      .deleteSurveyQuestions(payload)
      .then((data) => {
        localStorage.savingQuestions = false;
        console.log("Deleted question:", data);
        this.syncWithApi();
      })
      .catch((err) => {
        console.error("Failed to DELETE questions to API:", err);
      });

    this.event.questions.splice(index, 1);
    this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {});
    this.filterQuestions();
  }
}

QuestionsController.$inject = ["$localStorage", "$rootScope", "$state", "$stateParams", "auth", "env", "security", "$timeout", "tracking", "events"];

export default QuestionsController;



// WEBPACK FOOTER //
// ./client/app/scenes/postashiftwalkthrough/scenes/questions/questions.controller.js